<template>
  <a-dropdown v-if="props.closedLoopStatus">
    <a-tag :color="setColor(props.closedLoopStatus)">{{
      props.closedLoopStatus
    }}</a-tag>
  </a-dropdown>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    closedLoopStatus: String,
  },
  setup(props) {
    const closeLoopStatusColor = {
      不适用: "processing",
      进行中: "warning",
      已完成: "#87d068",
      未开始: "#f50",
    };
    const setColor = (text) => {
      const color = closeLoopStatusColor[text];
      if (!color) {
        return "default";
      }
      return color;
    };

    return {
      props,
      setColor,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
